import React, { useEffect, useState } from "react";

// Material Common Components
import ConfirmationModal from "examples/modal/Confirmation/Confirmation";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import BasicButton from "examples/NewDesign/CustomButton/BasicButton";
import DeleteModal from "examples/modal/deleteModal/deleteModal";
import FilterDropdown from "components/Dropdown/FilterDropdown";
import BasicModal from "examples/modal/BasicModal/BasicModal";
import AdddButton from "examples/NewDesign/CustomButton/AddButton";
import pxToRem from "assets/theme/functions/pxToRem";
import PageTitle from "examples/NewDesign/PageTitle";
import FTextField from "components/Form/FTextField";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

// Material Components
import { Divider, FormControlLabel, Radio, RadioGroup } from "@mui/material";

// Table
import salesManagerData from "layouts/leadUtils/salesManager/data/SalesManagerData";
import DataTable from "examples/Tables/DataTable";

// Redux
import {
  getAllSalesManagers,
  registerSalesManagers,
  updateSalesManagers,
  deleteSalesManagers,
} from "redux/Thunks/leadUtilsThunks";
import { openSnackbar } from "redux/Slice/Notification";
import { useDispatch } from "react-redux";

// Utils
import Constants, {
  PageTitles,
  ButtonTitles,
  Colors,
  Icons,
  defaultData,
  ModalContent,
} from "utils/Constants";
import { paramCreater } from "utils/methods/methods";
import Validations from "utils/Validations/index";
import ResetFilterButton from "components/Buttons/ResetButton";

function LeadUtilsCodes() {
  const [filters, setFilters] = useState([
    {
      inputLabel: "Status",
      list: [
        { [Constants.MONGOOSE_ID]: "All", title: "All" },
        { [Constants.MONGOOSE_ID]: "true", title: "Active" },
        { [Constants.MONGOOSE_ID]: "false", title: "In Active" },
      ],
      selectedValue: "All",
    },
  ]);
  const [tablePagination, setTablePagination] = useState({
    page: 0,
    perPage: defaultData.DATE_ON_SINGLE_API_CALL,
  });
  const [salesManagerBody, setSalesManagerBody] = useState({
    type: "new",
    openModal: false,
    body: {
      sm: "",
      status: true,
    },
    errors: {},
    openDeleteModal: false,
    openConfirmationModal: false,
    editDeleteId: "",
  });
  const dispatch = useDispatch();
  const [next, setNext] = useState(0);
  const [loading, setLoading] = useState(false);
  const [codeError, setCodeError] = useState({});
  const [salesManagerList, setCodeList] = useState([]);
  const [loadingStatus, setLoadingStatus] = useState(Constants.PENDING);

  const handleFilter = async (tempFilters = filters) => {
    setTablePagination({ ...tablePagination, page: 0 });
    const paramData = {
      page: defaultData.PAGE,
      perPage: tablePagination.perPage,
      ...(tempFilters[0].selectedValue !== "All" && { status: tempFilters[0].selectedValue }),
    };

    const res = await dispatch(getAllSalesManagers(paramCreater(paramData)));
    setLoadingStatus(Constants.FULFILLED);
    setCodeList(res.payload.data.data);
  };

  const handleResetFilter = () => {
    setFilters((prev) => [{ ...prev[0], selectedValue: "All" }]);
    handleFilter([{ ...filters[0], selectedValue: "All" }, ...filters.slice(1)]);
  };

  const handleFilterChange = (e) => {
    const temp = [...filters];
    const { value } = e.target;
    const index = filters.findIndex((filter) => filter.inputLabel === e.target.name);
    temp[index].selectedValue = value;
    setFilters(temp);
    handleFilter(temp);
  };

  const handleTablePagination = async () => {
    const data = {
      page: next + 1,
      perPage: tablePagination.perPage,
    };
    const res = await dispatch(getAllSalesManagers(paramCreater(data)));
    if (res.payload.status === 200) {
      setCodeList([...salesManagerList, ...res.payload.data.data]);
      setNext(res.payload.data.data.length > 0 ? next + 1 : next);
    }
  };

  useEffect(() => {
    (async () => {
      handleFilter();
    })();
  }, []);

  const handleEdit = (data) => {
    setSalesManagerBody((prevData) => ({
      ...prevData,
      type: "update",
      openModal: true,
      body: { ...data.body },
      editDeleteId: data.id,
    }));
  };

  const handleDelete = (id) => {
    setSalesManagerBody((prev) => ({ ...prev, openDeleteModal: true, editDeleteId: id }));
  };
  const handleCloseProfileFunctions = () => {
    setSalesManagerBody((prev) => ({
      ...prev,
      type: "new",
      openModal: false,
      body: {
        sm: "",
        status: true,
      },
      errors: {},
    }));
    setCodeError({});
  };

  const handleCloseDeleteProfileFunctionModal = () =>
    setSalesManagerBody((prev) => ({ ...prev, openDeleteModal: false }));

  const handleCloseConfirmationlModal = () =>
    setSalesManagerBody((prev) => ({ ...prev, openConfirmationModal: false }));

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSalesManagerBody((prev) => ({ ...prev, body: { ...prev.body, [name]: value } }));
  };

  const codesValidation = () => {
    const { body } = salesManagerBody;
    const errors = {};
    const questionError = Validations.validate("basic", body.sm);
    if (questionError !== "") {
      errors.name = questionError;
    }
    setCodeError(errors);
    return Object.values(errors).filter((val) => val !== "").length === 0;
  };

  const handleRegisterCodes = async () => {
    if (codesValidation()) {
      setLoading(true);
      const { body } = salesManagerBody;
      const res = await dispatch(registerSalesManagers(body));
      if (res.payload.status === 200) {
        handleFilter();
        dispatch(
          openSnackbar({
            message: Constants.LEAD_UTILS_SALES_MANAGER_CREATE_SUCCESS,
            notificationType: Constants.NOTIFICATION_SUCCESS,
          })
        );
        handleCloseProfileFunctions();
      } else if (res.payload.status === 401) {
        const temp = { ...codeError };
        temp.sm = res.payload.data.message;
        setCodeError(temp);
      } else {
        dispatch(
          openSnackbar({
            message: Constants.SOMETHING_WENT_WRONG,
            notificationType: Constants.NOTIFICATION_ERROR,
          })
        );
      }
      setLoading(false);
    }
  };

  const handleUpdateCodes = async () => {
    setLoading(true);
    if (codesValidation()) {
      const { body } = salesManagerBody;
      const res = await dispatch(updateSalesManagers(body));
      if (res.payload.status === 200) {
        handleFilter();
        dispatch(
          openSnackbar({
            message: Constants.LEAD_UTILS_SALES_MANAGER_UPDATE_SUCCESS,
            notificationType: Constants.NOTIFICATION_SUCCESS,
          })
        );
        handleCloseProfileFunctions();
      } else if (res.payload.status === 401) {
        const temp = { ...codeError };
        temp.sm = res.payload.data.message;
        setCodeError(temp);
      } else {
        dispatch(
          openSnackbar({
            message: Constants.SOMETHING_WENT_WRONG,
            notificationType: Constants.NOTIFICATION_ERROR,
          })
        );
      }
    }
    setLoading(false);
  };

  const handleUpdateStatus = async () => {
    const { body } = salesManagerBody;
    const res = await dispatch(updateSalesManagers(body));
    if (res.payload.status === 200) {
      handleFilter();
      dispatch(
        openSnackbar({
          message: Constants.LEAD_UTILS_SALES_MANAGER_UPDATE_SUCCESS,
          notificationType: Constants.NOTIFICATION_SUCCESS,
        })
      );
      handleCloseConfirmationlModal();
    } else {
      dispatch(
        openSnackbar({
          message: Constants.SOMETHING_WENT_WRONG,
          notificationType: Constants.NOTIFICATION_ERROR,
        })
      );
    }
  };

  const handleDeleteCodes = async () => {
    const { editDeleteId } = salesManagerBody;
    const res = await dispatch(deleteSalesManagers(editDeleteId));
    if (res.payload.status === 200) {
      handleFilter();
      await dispatch(
        openSnackbar({
          message: Constants.LEAD_UTILS_SALES_MANAGER_DELETE_SUCCESS,
          notificationType: Constants.NOTIFICATION_SUCCESS,
        })
      );
      handleCloseDeleteProfileFunctionModal();
    } else {
      dispatch(
        openSnackbar({
          message: Constants.LEAD_UTILS_SALES_MANAGER_DELETE_ERROR,
          notificationType: Constants.NOTIFICATION_ERROR,
        })
      );
    }
  };

  const handleStatusChange = (event, data) => {
    setSalesManagerBody((prev) => ({
      ...prev,
      openConfirmationModal: true,
      body: { ...data.body },
      editDeleteId: data?.id,
    }));
  };

  const handleReload = async () => {
    setLoadingStatus(Constants.PENDING);
    handleFilter();
  };
  const { columns, rows } = salesManagerData(
    salesManagerList,
    handleEdit,
    handleDelete,
    handleStatusChange
  );

  return (
    <DashboardLayout>
      <MDBox display="flex" justifyContent="space-between" alignItems="center">
        <PageTitle title={PageTitles.LEAD_UTILS_SALES_MANAGER} />
        <MDBox display="flex" flexDirection="row">
          <AdddButton
            title={ButtonTitles.LEAD_UTILS_SALES_MANAGER}
            icon={Icons.ADD}
            suffixIcon={Icons.SALES_MANAGER}
            background={Colors.WHITE}
            color={Colors.BLACK}
            action={() => setSalesManagerBody((prev) => ({ ...prev, openModal: true }))}
            ml={pxToRem(0)}
          />
          <Divider
            orientation="vertical"
            sx={{
              backgroundColor: "var(--gray-300, #D0D5DD)",
              height: "auto",
              marginLeft: pxToRem(16),
              marginRight: 0,
            }}
          />
          <BasicButton
            icon={Icons.RELOAD}
            background={Colors.WHITE}
            color={Colors.BLACK}
            action={handleReload}
          />
        </MDBox>
      </MDBox>
      <Divider sx={{ marginTop: 2 }} />
      <MDBox display="flex" alignItems="center">
        <MDBox
          display="flex"
          flexWrap="wrap"
          justifyContent="space-between"
          alignItems="start"
          sx={{ flexDirection: "row", mr: 2 }}
        >
          {filters &&
            filters.map((val) => (
              <FilterDropdown
                key={val.inputLabel}
                label={val.inputLabel}
                name={val.inputLabel}
                defaultValue={val?.selectedValue}
                value={val?.selectedValue}
                handleChange={handleFilterChange}
                menu={val.list}
              />
            ))}

          <ResetFilterButton handleReset={handleResetFilter} />
        </MDBox>
      </MDBox>
      <MDBox mt={3} mb={3}>
        <DataTable
          table={{ columns, rows }}
          isSorted={false}
          entriesPerPage={{ defaultValue: defaultData.PER_PAGE }}
          showTotalEntries={false}
          pagination={{ variant: "gradient", color: "info" }}
          loading={loadingStatus}
          currentPage={tablePagination.page}
          handleTablePagination={handleTablePagination}
          handleCurrentPage={(page) => setTablePagination({ ...tablePagination, page })}
        />
      </MDBox>

      {/* Create and Update Profile Function modal */}
      <BasicModal
        open={salesManagerBody.openModal}
        handleClose={handleCloseProfileFunctions}
        title={
          salesManagerBody.type === "new"
            ? ModalContent.CREATE_SALESMANAGER_TITLE
            : ModalContent.UPDATE_SALESMANAGER_TITLE
        }
        actionButton={
          (salesManagerBody.type === "new" && !loading && ButtonTitles.SUBMIT) ||
          (salesManagerBody.type === "new" && loading && ButtonTitles.SUBMIT_LOADING) ||
          (salesManagerBody.type === "update" && !loading && ButtonTitles.UPDATE) ||
          (salesManagerBody.type === "update" && loading && ButtonTitles.UPDATE_LOADING)
        }
        handleAction={salesManagerBody.type === "new" ? handleRegisterCodes : handleUpdateCodes}
      >
        <FTextField
          label="Sales Manager*"
          placeholder="Enter Sales Manager"
          id="sm"
          name="sm"
          type="text"
          error={Boolean(codeError?.sm)}
          helperText={codeError?.sm}
          value={salesManagerBody?.body?.sm}
          handleChange={handleChange}
          marginBottom={2}
        />
        {salesManagerBody.type === "new" ? (
          <MDBox>
            <MDTypography
              variant="caption"
              mb={1}
              mt={2}
              sx={{ fontSize: pxToRem(14), fontWeight: 500, color: "#344054" }}
            >
              Status
            </MDTypography>
            <RadioGroup
              name="status"
              value={salesManagerBody.body.status}
              onChange={handleChange}
              sx={{ display: "flex", flexDirection: "row" }}
            >
              <FormControlLabel label="Yes" value="true" control={<Radio />} />
              <FormControlLabel
                sx={{ marginLeft: "8px" }}
                label="No"
                value="false"
                control={<Radio />}
              />
            </RadioGroup>
          </MDBox>
        ) : null}
      </BasicModal>

      {/* Delete Modal for Profile Function */}
      <DeleteModal
        open={salesManagerBody.openDeleteModal}
        title={ModalContent.DELETE_SALESMANAGER_TITLE}
        message={ModalContent.DELETE_SALESMANAGER_MESSAGE}
        handleClose={handleCloseDeleteProfileFunctionModal}
        handleDelete={handleDeleteCodes}
      />

      {/* Confirmation Modal for Profile Function Status */}
      <ConfirmationModal
        open={salesManagerBody.openConfirmationModal}
        title={ModalContent.SALESMANAGER_STATUS_TITLE}
        message={
          salesManagerBody.body.isActive
            ? ModalContent.SALESMANAGER_ACTIVE_STATUS_MESSAGE
            : ModalContent.SALESMANAGER_INACTIVE_STATUS_MESSAGE
        }
        handleClose={handleCloseConfirmationlModal}
        handleAction={handleUpdateStatus}
      />
    </DashboardLayout>
  );
}

export default LeadUtilsCodes;
